// Filter translations by client and fallback languages
import { isNil, pick } from 'lodash';
import { createI18n } from 'vue-i18n';
import numeral from 'numeral';
import i18nconfig from '@sharedModules/config/static-i18n-config';
import { translations } from '../lang';

// Filter translations by client and fallback languages
const i18n = createI18n({
  locale: i18nconfig.defaultLocale, // client-specific. Overwritten on context load
  fallbackLocale: i18nconfig.fallbackLocale, // fallback language
  availableLocales: i18nconfig.availableLocales, // client-specific
  availableDateLocales: i18nconfig.availableDateLocales, // client-specific
  messages: {}, // No translations loaded here. See context where translations are dynamically loaded
  numberFormats: translations.numberFormats, // number formats for all locales
  silentTranslationWarn: true,
  silentFallbackWarn: true,
  datetimeFormats: translations.dateFormats,
  globalInjection: true, // https://github.com/intlify/vue-i18n-next/issues/350#issuecomment-782007971
  allowComposition: true,
  legacy: false,
  warnHtmlMessage: false,
});

// Default tranlsations available before the users logs in
i18n.global.setLocaleMessage('en', {
  footer: {
    manageCookiesButtonTitle: 'Manage Cookies',
    termsOfUse: 'Terms of Use',
    privacyNote: 'Privacy Notice',
    cookieNotice: 'Cookie Notice',
    solutionFrom: 'A solution from',
  },
  errorPage: {
    403: {
      title: 'Unauthorised',
      description: 'You are not authorised to view the resource',
    },
    404: {
      title: 'Not found',
      description: "The resource you are looking for doesn't exist",
    },
  },
});

i18n.n = function (
  format,
  value,
  { usePlaceholder = false, placeholder = '-', useAbsoluteValue = false } = {}
) {
  if (isNil(value) && usePlaceholder) return placeholder;

  // It is possible for the returned value to point to a key in our defaults
  // As we may want some clients to still have the default value whenever that changes
  // For docs on how this works see: https://owlabs.atlassian.net/wiki/spaces/RTLS/pages/1428127889/Number+Localisation
  if (
    i18n.global.te &&
    (i18n.global.te(`numbers.default.${format}`) ||
      i18n.global.te(`numbers.default.${format}`, i18nconfig.fallbackLocale))
  ) {
    format = i18n.global.t(`numbers.default.${format}`);
  }

  // Use numeralJS to convert value using locale and format and return it
  return numeral(useAbsoluteValue ? Math.abs(value) : value).format(format);
};

// Need to pick out specifc functions and add to the exported i18n due to vue3 upgrade
const globalI18n = pick(i18n.global, ['t', 'tc', 'setLocaleMessage']);
export default { ...i18n, ...globalI18n };
